import React, { useEffect, useState } from "react";
import api from "../utils/api";

const Downloads = () => {
  const [downloads, setDownloads] = useState([]);
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [downloadsRes, categoriesRes] = await Promise.all([
          api.get("/downloads"),
          api.get("/categories"),
        ]);
        console.log('Fetched downloads:', downloadsRes.data); // Log for debugging
        setDownloads(downloadsRes.data);
        setCategories(categoriesRes.data);
      } catch (err) {
        console.error("Error al cargar datos:", err);
        setError("No se pudieron cargar los datos. Intenta de nuevo más tarde.");
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  const visibleDownloads = downloads.filter((item) => item.is_visible === 'active');

  const getCategoryName = (categoryId) => {
    const category = categories.find((cat) => cat.id === categoryId);
    return category ? category.name : "Sin categoría";
  };

  return (
    <div className="bg-gray-50 min-h-screen">
      {/* Hero Section */}
      <div className="bg-gradient-to-b from-indigo-50 to-gray-50 py-16 text-center">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="text-4xl font-extrabold text-gray-900 sm:text-5xl">
            Descargas de APKs
          </h1>
          <p className="mt-4 text-lg text-gray-600">
            Encuentra las últimas versiones de APKs para tus dispositivos. Descarga de forma rápida y segura.
          </p>
        </div>
      </div>

      {/* Main Content */}
      <div className="max-w-7xl mx-auto py-12 px-4 sm:px-6 lg:px-8">
        {error ? (
          <div className="bg-red-50 rounded-lg p-6 text-center">
            <p className="text-red-700 text-lg font-medium">{error}</p>
            <button
              onClick={() => window.location.reload()}
              className="mt-4 inline-block px-6 py-2 bg-red-600 text-white rounded-md hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-red-500 transition-colors"
              aria-label="Reintentar carga de datos"
            >
              Reintentar
            </button>
          </div>
        ) : loading ? (
          <div className="text-center py-12">
            <p className="text-gray-600 text-lg font-medium">Cargando...</p>
          </div>
        ) : visibleDownloads.length === 0 ? (
          <div className="bg-white rounded-lg p-8 text-center shadow-sm">
            <p className="text-gray-700 text-lg font-medium">No hay APKs disponibles para descargar.</p>
          </div>
        ) : (
          <div className="grid gap-6 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
            {visibleDownloads.map((item) => (
              <div
                key={item.id}
                className="bg-white rounded-lg p-6 shadow-sm hover:shadow-md transition-all duration-300"
              >
                <div className="flex flex-col h-full">
                  {/* Title and Version Badge */}
                  <div className="flex justify-between items-center mb-3">
                    <h2 className="text-lg font-semibold text-gray-900 line-clamp-2">
                      {item.name}
                    </h2>
                    <span
                      className={`inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium ${
                        item.status === "active"
                          ? "bg-green-50 text-green-700"
                          : "bg-red-50 text-red-700"
                      }`}
                    >
                      {item.version || "Sin versión"}
                    </span>
                  </div>

                  {/* Description */}
                  <div
                    className="text-gray-600 text-sm mb-4 flex-grow line-clamp-3"
                    dangerouslySetInnerHTML={{
                      __html: item.description || "Sin descripción",
                    }}
                  />

                  {/* Category */}
                  <div className="text-sm text-gray-500 mb-3">
                    <span className="font-medium">Categoría:</span>{" "}
                    <span className="text-gray-700">{getCategoryName(item.category_id)}</span>
                  </div>

                  {/* Tags */}
                  {item.tags && item.tags.length > 0 && (
                    <div className="flex flex-wrap gap-1.5 mb-4">
                      {item.tags.split(",").map((tag, i) => (
                        <span
                          key={i}
                          className="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium bg-indigo-50 text-indigo-700"
                        >
                          {tag.trim()}
                        </span>
                      ))}
                    </div>
                  )}

                  {/* Downloader Info */}
                  <div className="text-sm text-gray-500 mb-4">
                    <p>
                      <span className="font-medium">Código:</span>{" "}
                      <span className="text-gray-700">{item.downloader_code || "-"}</span>
                    </p>
                    {item.downloader_url && (
                      <p className="mt-1">
                        <span className="font-medium">URL:</span>{" "}
                        <a
                          href={item.downloader_url}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="text-indigo-600 hover:underline"
                          aria-label={`Visitar URL de descarga para ${item.name}`}
                        >
                          {item.downloader_url}
                        </a>
                      </p>
                    )}
                  </div>

                  {/* Download Button */}
                  <a
                    href={`https://hoyvemos.com/download/${item.slug}`}
                    className="mt-auto block w-full bg-indigo-600 text-white text-center py-2 rounded-md hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 transition-colors"
                    download
                    aria-label={`Descargar ${item.name}`}
                  >
                    Descargar APK
                  </a>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default Downloads;
